import { Form, type FormInstance } from 'antd';
import { useCallback } from 'react';
import { getShiftTextRepresentation } from 'shared/utils/getShiftTextRepresentation';
import { getShiftRowSpan, isShiftStartIndex } from 'entities/bell-schedule/create';
import type { Bell, BellSchedule } from 'services/api';
import { getColumns } from './columns';

export const useBellScheduleForm = (
  form: FormInstance<BellSchedule>,
  readOnly?: boolean,
  shiftSeparatorClassName = '',
) => {
  const bells: Bell[] = Form.useWatch('bells', form) ?? [];

  const onTimeChange = useCallback(
    (index: number, field: 'startTime' | 'endTime', value: string) => {
      const currentBells = form.getFieldValue('bells') as Bell[];
      const updated = [...currentBells];
      updated[index] = { ...updated[index], [field]: value };
      form.setFieldsValue({ bells: updated });
      form.validateFields(['bells']);
    },
    [form],
  );

  const getShiftLabel = useCallback(
    (index: number) => {
      if (!isShiftStartIndex(index)) {
        return '';
      }

      const bell = bells[index];
      return bell ? getShiftTextRepresentation(bell.shift) : '';
    },
    [bells],
  );

  const getRowClassName = useCallback(
    (_record: Bell, index?: number) => {
      if (index === undefined || index === 0 || !shiftSeparatorClassName) {
        return '';
      }

      return index === 8 ? shiftSeparatorClassName : '';
    },
    [shiftSeparatorClassName],
  );

  const columns = getColumns(readOnly, onTimeChange, getShiftRowSpan, getShiftLabel);

  return {
    state: { bells, columns, getRowClassName },
    methods: {},
  };
};
